import carousels from './carousels.js';
import pages from './pages.js';

function v3(backendAxiosInstance) {
  return {
    ...carousels(backendAxiosInstance),
    ...pages(backendAxiosInstance)
  };
}

export { v3 as default };
//# sourceMappingURL=index.js.map
